import {useMutation} from "@tanstack/react-query";
import {inviteUserManagementUserMutationOptions} from "./invite-user-management-user.mutation-options";

export function useInviteUserManagementUser() {
  return useMutation(inviteUserManagementUserMutationOptions());
}
